<template>
  <div class="body">
    <div class="header">
      <el-form :model="ImpositionFileDTO" :inline="true">
 
        <el-form-item>
          <el-button size="small" type="primary" @click="tohandleEdit">新增</el-button>
          <el-button size="small" type="danger" @click="handleDelete">删除</el-button>
          
        </el-form-item>
      </el-form>

      <el-dialog
      title="编辑面板设置"
      :visible.sync="drawer"
      :direction="direction"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form
        ref="accountForm"
        :model="accountForm"
        label-width="100px"
        class="demo-accountForm"
      >
        <div style="margin: 10px"></div>
        <el-form-item label="面板材料" prop="name">
          <el-input
            class="input-name"
            size="small"
            v-model="accountForm.panelMaterial"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 20px" label="外扩值" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.outreachValue"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 20px" label="实际厚度" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.actualThickness"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 20px" label="修图范围" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.density"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 20px" label="拼版价格" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.price"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 20px" label="面板雕刻设置" prop="remark">
          <el-select clearable size="small" v-model="accountForm.schemeName">
            <el-option
              v-for="item in schemeName"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="submitForm('accountForm')"
          >
            立即创建
          </el-button>
      
        </el-form-item>
      </el-form>
    </el-dialog>

      <div style="display: flex">
        <el-upload
          class="upload-demo"
          action="#"
          accept="xlsx,xls"
          multiple
          :limit="1"
          :auto-upload="false"
          :with-credentials="false"
          :show-file-list="false"
          :on-change="loadFile"
        >
        <!-- <el-button size="small" type="primary">导入</el-button> -->
        </el-upload>
        <!-- <el-button
          size="small"
          style="margin-left: 10px"
          type="primary"
          @click="exportExcelData"
        >
          导出
        </el-button> -->
       
      </div>
      
    </div>
    <div style="margin: 10px">
      <el-table
        :data="conTract"
        stripe
        border
        style="width: 100%"
        :cell-style="styleBack"
        @selection-change="handleSelectionChange"
      >
      <el-table-column
        type="selection"
        align="center"
        width="55"
      ></el-table-column>
        <el-table-column
          prop="panelMaterial"
          align="center"
          label="面板材料"
        ></el-table-column>
        <el-table-column
          prop="outreachValue"
          align="center"
          label="外扩值"
        ></el-table-column>
        <el-table-column
            prop="actualThickness"
            align="center"
            label="实际厚度"
          ></el-table-column>
          <el-table-column
            prop="density"
            align="center"
            label="修图范围"
          ></el-table-column>
          <el-table-column
            prop="price"
            align="center"
            label="拼版价格"
          ></el-table-column>
        <el-table-column
          prop="schemeName"
          align="center"
          label="面板雕刻设置名称"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          label="设置时间"
          width="250"
        ></el-table-column>
    
        <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>
       
      </el-table>
    </div>

    <el-dialog title="编辑面板设置" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
      <el-form
        ref="accountForm"
        :model="accountForm"
        label-width="100px"
        class="demo-accountForm"
      >
        <el-form-item label="面板材料" prop="outreachValue">
          <el-input v-model="accountForm.panelMaterial" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="外扩值" prop="panelMaterial">
          <el-input v-model="accountForm.outreachValue" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="实际厚度" prop="panelMaterial">
            <el-input v-model="accountForm.actualThickness" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="修图范围" prop="panelMaterial">
            <el-input v-model="accountForm.density" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="拼版价格" prop="panelMaterial">
            <el-input v-model="accountForm.price" type="textarea"></el-input>
          </el-form-item>
        <el-form-item style="margin-top: 20px" label="面板雕刻设置" prop="remark">
          <el-select clearable size="small" v-model="accountForm.schemeName">
            <el-option
              v-for="item in schemeName"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editAccount()">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { selectPanel,upDatePanel,bathDeleteFile,addPanel,selectPanelName} from '@/api/panel'
export default {
  data() {
    return {
    direction: 'rtl',
      pageSize: 10,
      total: 0,
      currentPage: 1,
      multipleSelection: [],
      ids: '',
      drawer: false,
      access: '',
      date: '',
      dialogVisible: false,
      conTract: [],
      schemeName:[],
      accountForm: {
        actualThickness:'',
          density:'',
          price:'',
        schemeName:'',
        outreachValue: '',
        panelMaterial: '',
        id:'',
        access:''
      },
      ImpositionFileDTO:{
          startTime: '',
          endTime: '',
         
          status: '2'
      },
      searchForm: {
        startTime: '',
        secondStartTime: '',
        number: '',
        values: ''
      },
      DeleteDTO:{
        id:'',
      }
    }
  },
  

  mounted() {
    
    this.access=localStorage.getItem("access")
    this.accountForm.access=localStorage.getItem("access")
    this.selectPanelName()
    this.getTableData() // 进入页面调用一次获取数据的方法
  },
  methods: {
    styleBack({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex == 0) {
      //   return { color: '#0c87ef' }
      // }
    },
    tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.drawer = true
      },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getTableData()
    },
    getTableData() {
        selectPanel( this.access).then((res) => {
        this.conTract = res.data.data
      //  this.total = Number(res.data.data.total)
      })
    },
    selectPanelName(){
      selectPanelName(this.access).then((res) => {
        console.log(res)
        this.schemeName = res.data.data
      //  this.total = Number(res.data.data.total)
      })
    },
    // 导入
    loadFile(file, fileList) {
      console.log(file, fileList)
      const formdata = new FormData()
      fileList.map((item) => {
        // fileList本来就是数组，就不用转为真数组了
        formdata.append('file', item.raw) // 将每一个文件图片都加进formdata
      })
      leadingIn(formdata).then((res) => {
        // console.log(res)
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '导入成功!'
          })
          this.getTableData()
        }
      })
    },

    handleEdit(row) {
      this.dialogVisible = true
      console.log(row)
      this.accountForm = row
    },
    submitForm(accountForm) {
   
        console.log(this.accountForm)
      this.$refs[accountForm].validate((valid) => {
        if (valid) {
            addPanel(this.accountForm).then((res) => {
                if (res.data.msg === '操作成功') {
            this.drawer = false
            this.$message({
              type: 'success',
              message: '添加成功!',
              
            }),
            this.getTableData()

          } else if (res.data.msg !== '操作成功') {
            this.$message({
              type: 'info',
              message: res.data.data
            })
          }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleDelete() {
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          } 
    this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        bathDeleteFile(this.multipleSelection).then((res) => {
          if (res.data.msg === '操作成功') {
            this.$message({
              type: 'success',
              message: '删除成功!',
            }),
            this.getTableData()

          } else if (res.data.msg !== '操作成功') {
            this.$message({
              type: 'info',
              message: res.data.date
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
  },
   

  
    deleteInfo(){
      bathDeleteFile(this.multipleSelection).then((res) => {
          if(res.data.code===10000){
            this.getTableData()
          }
      })
    },
    //修改
    editAccount() {
        upDatePanel(this.accountForm).then((res) => {
        if (res.data.msg === '操作成功') {
          this.dialogVisible = false
            this.getTableData()
          this.$message({
            type: 'success',
            message: '保存成功!'
          })
        } else if (res.data.msg!== '操作成功') {
          this.$message({
              type: 'info',
              message: res.data.data
            })
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出
    exportExcelData() {
      exportData(this.searchForm, this.currentPage, this.total)
        .then((res) => {
          if (res.status == 200) {
            exportExcel(res.data, res)
            this.$message({
              type: 'success',
              message: '导出成功!'
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    chooeDate(e) {
      // console.log(e)
      if (e) {
        this.ImpositionFileDTO.startTime = e[0]
        this.ImpositionFileDTO.endTime = e[1]
      } else if (!e) {
        this.ImpositionFileDTO.startTime = ''
        this.ImpositionFileDTO.endTime = ''
      }
    },
    // 搜索
    serchInfo() {
      this.getTableData()
    },

  
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 20px;
}
.body {
  overflow: auto;
}

.pagination {
  margin-top: 10px;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  position: relative;
}
.el-pagination ::v-deep.el-pagination__total {
  line-height: 36px;
}
</style>
